// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8e889764","455":"0258bd5d","946":"f70339d8"}[chunkId] + ".chunk.js";
};